import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster richColors position="top-right" />
        </div>
    );
}

export default App;
